﻿import React, { useState, useEffect } from 'react';

import { InfoWindow } from '@react-google-maps/api';
import { products } from '../../../BookingFlowPage/Scripts/Endpoints'

const InfoWindowWidget = ({ facilitySearchContext, keyboardEvent, selectedPlace, anchor, onClose, prevSelectedPlace }) => {
  const lang = {
    ...facilitySearchContext.localization.inputs,
    ...facilitySearchContext.localization.headings,
    ...facilitySearchContext.localization.filter
  };
  const [icons, setIcons] = useState(null);
  const serviceList = new Array();
  const selectedLocale = facilitySearchContext.episerver.selectedlanguage === 'no' ? 'nb' : facilitySearchContext.episerver.selectedlanguage === 'se' ? 'sv' : facilitySearchContext.episerver.selectedlanguage;
  const imageAltText = selectedLocale == "sv" ? "kampanj ikon" : selectedLocale == "fi" ? "kampanjakuvake" : selectedLocale == "nb" ? "kampanjeikon" : "campaign icon";

  useEffect(() => {
    let isSubscribed = true;    
    const getIcons = async () => {
      const listItems = document.querySelector('.facilitysearchpage__list')?.querySelectorAll('.facilitysearchpage__listitem');
      if (!listItems || !listItems.length) return;
      let hasPromotion = false;
      let hasAvailableSpot = false;
      let hasLowAvailability = false;
      const selectedPlaceItem = Array.from(listItems).find(item => item.getAttribute('data-facility-uid') === selectedPlace.Uid);
      if (!selectedPlaceItem) {
        const allProducts = await products.getProducts({ bookingController: facilitySearchContext.episerver.bookingController, fId: selectedPlace.Uid, lang: selectedLocale, includeNotBookableOnline: true, availabilityFrom: facilitySearchContext.searchDate || null });
        if (allProducts.status === 200 && allProducts.body.Places.length > 0 && isSubscribed) {
          const listOfProducts = allProducts.body.Places.map(zone => zone.Item2).flat();
          hasPromotion = listOfProducts.some(product => Array.isArray(product.Promotions) && product.Promotions.length > 0);
          if (!facilitySearchContext.episerver.hideAvailability) {
            hasAvailableSpot = listOfProducts.some(product => product.Availability && product.Availability > 0);
            hasLowAvailability = !listOfProducts.some(product => product.Availability && product.Availability > 4);
          }
        }
      } else {
        hasPromotion = !!selectedPlaceItem.querySelector('img');
        if (!facilitySearchContext.episerver.hideAvailability) {
          hasAvailableSpot = !!selectedPlaceItem.querySelector('.left--availablespot');
          hasLowAvailability = selectedPlaceItem.querySelector('.left--availablespot')?.dataset.low?.toLowerCase() === 'true';
        }
      }
      setIcons({ hasPromotion, hasAvailableSpot, hasLowAvailability });
    }
    getIcons();
    return () => isSubscribed = false;
  }, [])

  if (selectedPlace.Indoor) {
    serviceList.push({
      id: "type",
      text: lang.info.indoor.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.Outdoor) {
    serviceList.push({
      id: "type",
      text: lang.info.outdoor.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.Info && selectedPlace.Info.Heated) {
    serviceList.push({
      id: "heated",
      text: lang.info.heated.replaceAll('&shy;', '\xAD')
    }); 
  }

  if (selectedPlace.Info && (selectedPlace.Info.maxVehicleHeight && selectedPlace.Info.MaxVehicleHeight > 200 || !selectedPlace.Info.MaxVehicleHeight)) {
    serviceList.push({
      id: "maxVehicleHeight",
      text: lang.info.maxVehicleHeight.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.Services && selectedPlace.Services.includes('electricChargingPoint')) {
    serviceList.push({
      id: "electricChargingPoint",
      text: lang.services.electricchargingpoint.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.Services && selectedPlace.Services.includes('disabled')) {
    serviceList.push({
      id: "disabled",
      text: lang.services.disabled.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.HasStp) {
    serviceList.push({
      id: "stp",
      text: lang.info.STP.replaceAll('&shy;', '\xAD')
    });
  }

  if (selectedPlace.HasLtp) {
    serviceList.push({
      id: "ltp",
      text: lang.info.LTP.replaceAll('&shy;', '\xAD')
    });
  }

  return (
    <InfoWindow anchor={anchor} onCloseClick={() => onClose()}>
      <div className={['facilitysearchpage__map__info', !keyboardEvent ? "facilitysearchpage__map__info--nofocus" : null].join(' ')}>
        <h3><a href={selectedPlace.Url} onClick={(e) => { if (!selectedPlace.Url) e.preventDefault() }}>{selectedPlace.Name}</a></h3>
        <p>{selectedPlace.Address.Street}{selectedPlace.Address.Number && ` ${selectedPlace.Address.Number}`}, {selectedPlace.Address.PostCode} {selectedPlace.Address.City}</p>
        {icons && (icons.hasPromotion || icons.hasAvailableSpot) && <div className='facilitysearchpage__map__info--promo-and-availability'>
          {icons.hasAvailableSpot && !facilitySearchContext.episerver.hideAvailability && <span data-low={icons.hasLowAvailability.toString()}>{icons.hasLowAvailability ? lang.lowavailability : lang.availability}</span>}
          {icons.hasPromotion && <img src={`/publicResources/icons/promo/${selectedLocale}/Promotion2_${selectedLocale}.svg`} alt={imageAltText} />}
        </div>}
        {serviceList.length > 0 && (
          <p className="services">
            {serviceList.map(service => (
              <span key={service.id}>{service.text}</span>
            ))}
          </p>
        )}
      </div>
    </InfoWindow>
  )
}

export default InfoWindowWidget;
